<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div class="flex-grow-1" :class="backgroundClass" role="main">
      <AlertConnectionLost v-if="!onLine" />
      <div v-if="getToken != ''">
        <AlertSessionExpired v-if="isExpired" />
        <AlertSessionExpiring
          :minutes="minutes"
          v-else-if="timeRemaining <= minutes * 60"
        />
      </div>
      <div v-if="!hasError || isDebugMode">
        <div v-if="isReady" class="h-100">
          <router-view />
          <div class="w-50 mx-auto d-none">
            <DebugSession @session-expired="setExpired" />
          </div>
        </div>
        <div v-else class="pt-3">
          <AlertLoading />
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader";
import TheFooter from "@/components/core/TheFooter";
import TheNavbar from "@/components/core/TheNavbar";
import AlertLoading from "@/components/core/AlertLoading";
import AlertConnectionLost from "@/components/core/AlertConnectionLost";
import AlertSessionExpired from "@/components/core/AlertSessionExpired";
import AlertSessionExpiring from "@/components/core/AlertSessionExpiring";

// API for performing CRUD operations from the Datastore
import DatastoreAPI from "@/helpers/DatastoreAPI";
import DebugSession from "@/components/debug/DebugSession";

import { mapState, mapActions, mapGetters } from "vuex";

import config from "@/data/config";

export default {
  name: "App",
  mixins: [DatastoreAPI],
  data() {
    return {
      onLine: navigator.onLine,
      timeRemaining: 0,
      minutes: 10,
      backgroundClass: config.appStyle.backgroundClass,
      expired: false
    };
  },
  components: {
    TheHeader,
    TheNavbar,
    TheFooter,
    AlertLoading,
    AlertConnectionLost,
    AlertSessionExpired,
    AlertSessionExpiring,
    DebugSession
  },
  computed: {
    ...mapGetters(["getExpirationTime", "isDebugMode"]),
    ...mapGetters("datastore", ["getEntry"]),
    ...mapState("datastore", ["entryLoaded", "entriesLoaded"]),
    isOnline() {
      return navigator.onLine || this.online;
    },
    isExpired() {
      return this.timeRemaining <= 0 || this.expired;
    },
    isReady() {
      const meta = this.$route.meta;

      // Does this view need the current user's data?
      //   If so, wait until it is loaded.
      if (meta?.readEntry && !this.entryLoaded) {
        return false;
      }

      // Does this view need all users data?
      //   If so, wait until it is loaded.
      else if (meta?.readEntries && !this.entriesLoaded) {
        return false;
      }

      // Any additional APIs?

      // We are not waiting on anything.
      // we are ready to render the view

      return true;
    },
    hasError() {
      if (!this.isOnline) {
        return true;
      }

      if (this.isExpired) {
        return true;
      }

      return false;
    }
  },
  methods: {
    ...mapActions(["mapFromDatastore"]),
    checkConnectionStatus() {
      this.onLine = navigator.onLine;
    },
    setExpired() {
      this.expired = true;
    },
    checkTimeRemaining() {
      let secondsRemaining =
        this.getExpirationTime - Math.floor(Date.now() / 1000);
      //const HOUR = 60 * 60; // minutes * seconds
      //secondsRemaining -= HOUR * 5.99; -- todo - testing

      this.timeRemaining = secondsRemaining;
      setTimeout(() => {
        this.checkTimeRemaining();
      }, 5000);
    }
  },
  watch: {
    $route() {
      // Does the current route need to load an entry or entries?
      // If so, load the entry, and map into Vuex
      if (this.$route.meta?.readEntry) {
        this.readEntry(() => this.mapFromDatastore(this.getEntry));
      }

      if (this.$route.meta?.readEntries) {
        this.readEntries();
      }
    },
    getToken() {
      this.checkTimeRemaining();
    }
  },
  created() {
    window.addEventListener("offline", this.checkConnectionStatus);
    window.addEventListener("online", this.checkConnectionStatus);
  }
};
</script>
